import { axios } from 'libs';

const resource = '/protocolo/config';

export const getConfig = entidade => {
  return axios.get(entidade ? `${resource}/${entidade}` : resource);
};
